import { render, staticRenderFns } from "./BonusProblemDiscrepancy.vue?vue&type=template&id=69127eae&"
import script from "./BonusProblemDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./BonusProblemDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports